import { render, staticRenderFns } from "./NewsComponent.vue?vue&type=template&id=d256900e"
import script from "./NewsComponent.vue?vue&type=script&lang=js"
export * from "./NewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d256900e')) {
      api.createRecord('d256900e', component.options)
    } else {
      api.reload('d256900e', component.options)
    }
    module.hot.accept("./NewsComponent.vue?vue&type=template&id=d256900e", function () {
      api.rerender('d256900e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/NewsComponent.vue"
export default component.exports